import React from 'react';
import { FormTemplateQuestionFieldsKindEnum } from 'graphql-common';
import Input from '@lib/components/Input/Input';
import { InputTypes } from '@lib/components/Input/enums';
import { ComponentProps, defaultProps } from '../types';

export default function NumberInputPreview({ t }: ComponentProps) {
  return (
    <Input
      {...defaultProps}
      type={InputTypes.number}
      label={t('number-input')}
      name={`${FormTemplateQuestionFieldsKindEnum.Input}-preview`}
    />
  );
}
